import Color from 'color';
import {kebabCase} from 'es-toolkit';

import type {Theme, Themes} from '../theme';

import {platform} from '../../utils/platform';

const generateCssVars = (obj: object, prefix?: string): string => {
  let result = '';

  Object.keys(obj).forEach(key => {
    if (key === 'id' || key.includes('statusBar')) {
      return;
    }

    if (typeof obj[key] === 'string') {
      result += `--${prefix ? `${kebabCase(prefix)}-` : ''}${kebabCase(key)}: ${
        obj[key]
      };`;

      if (prefix?.includes('color')) {
        result += `--${prefix ? `${kebabCase(prefix)}-` : ''}${kebabCase(key)}-rgb: ${Color(obj[key]).array().join()};`;
      }
    } else {
      result += generateCssVars(obj[key], prefix ? `${prefix}-${key}` : key);
    }
  });

  return result;
};

export const appendStyle = (style: string, id?: string): void => {
  if (platform.isNative) {
    return;
  }

  let styleElement: HTMLStyleElement;

  const styleId = id || 'appendStyleId';

  const hasStyleElement = document.getElementById(styleId);

  if (hasStyleElement) {
    styleElement = document.getElementById(styleId) as HTMLStyleElement;
  } else {
    styleElement = document.createElement('style');
    styleElement.id = styleId;
  }

  styleElement.innerHTML = style;

  if (!hasStyleElement) {
    document.head.appendChild(styleElement);
  }
};

export const generateCssTheme = (
  currentTheme: Theme['id'],
  themes: Themes,
): string => {
  const cssTheme = generateCssVars(themes[currentTheme]);

  const cssLightTheme = generateCssVars(themes.light, 'light');

  const cssDarkTheme = generateCssVars(themes.dark, 'dark');

  // @see https://lukelowrey.com/css-variable-theme-switcher/
  const css = `
    :root {
      ${cssTheme};
      ${cssLightTheme};
      ${cssDarkTheme};
    }
    html[data-theme='light'] {
      ${cssLightTheme};
    }
    html[data-theme='dark'] {
      ${cssDarkTheme};
    }
`;

  return css;
};
